<template>
  <el-container class="workspace-page employees-page">
    <el-header height="auto" class="workspace-toolbar">
      <div class="employee-toolbar-row">
        <span class="employee-toolbar-count">
          <i class="el-icon-user" aria-hidden="true"></i>
          {{ $t("公司活跃人数：") }}<strong>{{ companyActiveUserCount }}</strong> {{ $t("人") }}
        </span>
        <el-button v-if="isEnterpriseAdmin && selectedEmployees.length > 0"
                   type="primary"
                   @click="editMultipleEmployeesDialog.visible = true">
          {{ $t("批量修改 {p0} 人的部门", { p0: selectedEmployees.length }) }}
        </el-button>
      </div>
      <el-dialog
          :visible.sync="editEmployeeDialog.visible"
          :title="$t('编辑员工资料')"
          width="30%">
        <el-row justify="space-between" type="flex">
                    <span style="height: 100%;">
                        <span style="height: 100%; line-height: 40px;">{{ $t("部门") }}</span>
                    </span>
          <span style="margin: 0 0 0 10px;">
                        <el-select v-model="editEmployeeDialog.departmentId" :placeholder="$t('待加入的部门')">
                            <el-option
                                v-for="item in departments"
                                :key="item.depId"
                                :label="item.displayName || item.name"
                                :value="item.depId">
                            </el-option>
                        </el-select>
                    </span>
        </el-row>

        <span slot="footer" class="dialog-footer">
                    <el-button @click="editEmployeeDialog.visible = false">{{ $t("取 消") }}</el-button>
                    <el-button type="primary" @click="editEmployeeDialogConfirmed">{{ $t("确 定") }}</el-button>
                </span>
      </el-dialog>

      <el-dialog
          :visible.sync="editMultipleEmployeesDialog.visible"
          :title="$t('编辑员工资料')"
          width="30%">
        <el-row justify="space-between" style="margin: 10px 0 0 0;" type="flex">
                    <span style="height: 100%;">
                        <span style="height: 100%; line-height: 40px;">{{ $t("部门") }}</span>
                    </span>
          <span style="margin: 0 0 0 10px;">
                        <el-select v-model="editMultipleEmployeesDialog.departmentId" :placeholder="$t('待加入的部门')">
                            <el-option
                                v-for="item in departments"
                                :key="item.depId"
                                :label="item.displayName || item.name"
                                :value="item.depId">
                            </el-option>
                        </el-select>
                    </span>
        </el-row>

        <span slot="footer" class="dialog-footer">
                    <el-button @click="editMultipleEmployeesDialog.visible = false">{{ $t("取 消") }}</el-button>
                    <el-button type="primary" @click="editMultipleEmployeesDialogConfirmed">{{ $t("确 定") }}</el-button>
                </span>
      </el-dialog>
    </el-header>
    <el-main class="workspace-content">
      <div class="employee-cards">
        <el-card
          v-for="employee in employees"
          :key="employee.userId"
          class="employee-card"
          :class="{ 'employee-card--selected': isEmployeeSelected(employee) }"
          shadow="never">
          <div class="employee-card-header">
            <div class="employee-card-name">
              <span class="employee-card-name__text">{{ employee.name || '—' }}</span>
              <el-tag v-if="employee.roleId === 1" size="mini" type="success">{{ $t("企业管理员") }}</el-tag>
            </div>
            <div v-if="isEnterpriseAdmin" class="employee-card-controls">
              <button
                class="employee-select-button"
                :class="{ 'employee-select-button--active': isEmployeeSelected(employee) }"
                type="button"
                :aria-label="$t('{p0}{p1}进行批量操作', { p0: isEmployeeSelected(employee) ? $t('取消选择') : $t('选择'), p1: employee.name || $t('该员工') })"
                :aria-pressed="isEmployeeSelected(employee) ? 'true' : 'false'"
                @click="toggleEmployeeSelection(employee, !isEmployeeSelected(employee))">
                <span class="employee-select-button__indicator" aria-hidden="true">
                  <i v-if="isEmployeeSelected(employee)" class="el-icon-check"></i>
                </span>
                <span>{{ isEmployeeSelected(employee) ? $t("已选择") : $t("批量选择") }}</span>
              </button>
              <el-dropdown
                class="employee-actions-dropdown"
                placement="bottom-end"
                trigger="click"
                @click.native.stop
                @command="handleEmployeeCommand($event, employee)">
                <button
                  class="employee-actions-button"
                  type="button"
                  :aria-label="$t('管理{p0}', { p0: employee.name || $t('该员工') })">
                  <i class="el-icon-more" aria-hidden="true"></i>
                </button>
                <el-dropdown-menu slot="dropdown" class="employee-action-menu">
                  <el-dropdown-item command="edit">
                    <i class="el-icon-edit-outline" aria-hidden="true"></i>
                    <span>{{ $t("编辑部门") }}</span>
                  </el-dropdown-item>
                  <el-dropdown-item command="remove" divided class="employee-action-menu__danger">
                    <i class="el-icon-remove-outline" aria-hidden="true"></i>
                    <span>{{ $t("移出企业") }}</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div class="employee-card-row">
            <span class="employee-card-label">{{ $t("部门") }}</span>
            <span class="employee-card-value">{{ (employee.department && employee.department.name) ? employee.department.name : '—' }}</span>
          </div>
          <div class="employee-card-row">
            <span class="employee-card-label">{{ $t("上次登录") }}</span>
            <span class="employee-card-value">{{ employee.lastLoginRelativeTime || '—' }}</span>
          </div>
          <div v-if="hasIssueMetrics(employee)" class="employee-card-metrics">
            <section
              v-for="group in visibleMetricGroups(employee)"
              :key="group.key"
              class="employee-metric-group"
              :class="`employee-metric-group--${group.key}`"
              role="group"
              :aria-label="metricGroupDescription(employee, group)">
              <div class="employee-metric-equation">
                <div class="employee-metric-total">
                  <span>{{ group.label }}</span>
                  <div>
                    <strong>{{ metricValue(employee, group.totalKey) }}</strong>
                    <small>{{ $t("条") }}</small>
                  </div>
                </div>
                <span class="employee-metric-equals" aria-hidden="true">=</span>
                <div class="employee-metric-breakdown">
                  <div
                    v-for="item in group.items"
                    :key="item.key"
                    class="employee-metric-item"
                    :class="`employee-metric-item--${item.tone}`">
                    <strong>{{ metricValue(employee, item.key) }}</strong>
                    <span>{{ item.label }}</span>
                  </div>
                </div>
              </div>
              <div class="employee-metric-bar" aria-hidden="true">
                <span
                  v-for="item in group.items"
                  :key="item.key"
                  class="employee-metric-bar__segment"
                  :class="`employee-metric-bar__segment--${item.tone}`"
                  :style="metricSegmentStyle(employee, group, item)">
                </span>
              </div>
            </section>
          </div>
        </el-card>
        <div v-if="!employees.length && !loading" class="employee-empty">{{ $t("暂无员工数据") }}</div>
        <div v-if="loading" class="employee-empty">{{ $t("加载中...") }}</div>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import { t } from "@/i18n";
import axios from "axios";
import app from "@/App";
import { getCompanyIdFromToken } from "@/utils/refreshToken";

export default {
  name: "Employees",
  data() {
    return {
      user: {},
      dialogVisible: false,
      employees: [],
      departments: [],


      editEmployeeDialog: {
        visible: false,
        employee: {},
        departmentId: null,
      },

      editMultipleEmployeesDialog: {
        visible: false,
        departmentId: null,
      },

      selectedEmployees: [],

      companyUserStats: null,
      pageSize: 20,
      nextCursor: null,
      hasMore: true,
      loading: false,
      scrollHandler: null,
    }
  },
  created() {
    app.methods.getUser().then((res) => {
      this.user = res.data;
      this.getEmployees();
      this.getDepartments();
    })
    this.scrollHandler = () => this.loadNextEmployeePageIfNeeded();
    window.addEventListener('scroll', this.scrollHandler);
  },
  beforeDestroy() {
    if (this.scrollHandler) {
      window.removeEventListener('scroll', this.scrollHandler);
      this.scrollHandler = null;
    }
  },
  computed: {
    issueMetricGroups() {
      return [
        {
          key: 'record',
          label: t("记录"),
          totalKey: 'issueCreated',
          items: [
            { key: 'issueUnsolved', label: t("待解决"), tone: 'danger' },
            { key: 'issueUnverify', label: t("待验收"), tone: 'warning' },
            { key: 'issueSolve', label: t("已验收"), tone: 'success' },
          ],
        },
        {
          key: 'solution',
          label: t("解决"),
          totalKey: 'issueSolved',
          items: [
            { key: 'issueUnverified', label: t("待验收"), tone: 'warning' },
            { key: 'issueRejected', label: t("未通过"), tone: 'danger' },
            { key: 'issueVerified', label: t("已验收"), tone: 'success' },
          ],
        },
      ];
    },
    companyId() {
      return getCompanyIdFromToken() || (this.user && this.user.company && this.user.company.companyId) || null;
    },
    companyActiveUserCount() {
      if (this.companyUserStats && typeof this.companyUserStats.activeUserCount === 'number') {
        return this.companyUserStats.activeUserCount;
      }
      return '—';
    },
    isEnterpriseAdmin() {
      return this.user && this.user.roleId === 1;
    },
  },
  methods: {
    getCompanyUserStats() {
      if (!this.companyId) {
        this.companyUserStats = null;
        return;
      }
      app.methods
          .getCompanyUserStats(this.companyId)
          .then((stats) => {
            const rawActiveUserCount = stats && stats.activeUserCount;
            const activeUserCount = rawActiveUserCount === null || rawActiveUserCount === undefined || rawActiveUserCount === ''
              ? Number.NaN
              : Number(rawActiveUserCount);
            this.companyUserStats = Number.isFinite(activeUserCount)
              ? { ...stats, activeUserCount }
              : null;
          })
          .catch(() => {
            this.companyUserStats = null;
          });
    },
    loadNextEmployeePageIfNeeded() {
      if (this.loading || !this.hasMore) return;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
      const fullHeight = document.documentElement.scrollHeight || document.body.scrollHeight || 0;
      if (scrollTop + viewportHeight >= fullHeight - 140) {
        this.getEmployees(false);
      }
    },
    async getDepartments() {
      if (!this.companyId) {
        this.$message.error(t("无法获取企业信息"));
        return;
      }
      const response = (
        await app.methods.getAllDepartmentsOfCompany(
          this.companyId,
          undefined
        )
      ).data;
      const toDisplayName = (department) => {
        let parents = [];
        if (Array.isArray(department.parents)) {
          const names = [];
          for (const parent of department.parents) {
            if (!parent || !parent.name) {
              continue;
            }
            const parentId = parent.parentId;
            if (parentId === 0 || parentId === '0') {
              break;
            }
            names.push(parent.name);
          }
          parents = names;
        }
        if (parents.length === 0) {
          return department.name;
        }
        return `${parents.join(' · ')} / ${department.name}`;
      };
      this.departments = Array.isArray(response)
        ? response
            .map(dep => ({
              ...dep,
              depId: dep.depId || dep.departmentId || dep.department_id || null,
              displayName: toDisplayName(dep),
            }))
            .filter(dep => dep.depId)
        : [];
    },

    getEmployees(reset = true) {
      if (!this.companyId) {
        this.$message.error(t("无法获取企业信息"));
        return;
      }
      if (this.loading || (!reset && !this.hasMore)) return;
      this.loading = true;
      if (reset) {
        this.employees = [];
        this.nextCursor = null;
        this.hasMore = true;
        this.getCompanyUserStats();
      }
      app.methods
          .getEmployeesPage(this.companyId, this.nextCursor, this.pageSize)
          .then((payload) => {
            const records = Array.isArray(payload.records) ? payload.records : [];
            this.employees = reset ? records : this.employees.concat(records);
            this.nextCursor = payload.nextCursor || null;
            this.hasMore = Boolean(this.nextCursor && records.length > 0);
          })
          .catch((error) => {
            const message = error && error.response && error.response.data && error.response.data.message
              ? error.response.data.message
              : t("获取员工列表失败");
            this.$message.error(message);
          })
          .finally(() => {
            this.loading = false;
            this.$nextTick(() => this.loadNextEmployeePageIfNeeded());
          });
    },
    editEmployeeDialogConfirmed() {
      app.methods.setEmployeeDepartment(this.editEmployeeDialog.employee.userId, this.editEmployeeDialog.departmentId)
          .then(() => {
            this.$notify.success({title: t("修改部门成功"), message: null});
            this.getEmployees();
            this.editEmployeeDialog.visible = false;
          })
          .catch(error => {
            const message = error && error.response && error.response.data && error.response.data.message
                ? error.response.data.message
                : t("修改部门失败");
            this.$notify.error({title: t("提示"), message, duration: 0});
          });
    },
    editEmployeeButtonClicked(employee) {
      this.editEmployeeDialog.employee = employee;
      this.editEmployeeDialog.visible = true;
      const currentDepartmentId =
        employee.depId
        || employee.departmentId
        || (employee.department && (employee.department.depId || employee.department.departmentId))
        || null;
      this.editEmployeeDialog.departmentId = currentDepartmentId;
    },
    async editMultipleEmployeesDialogConfirmed() {
      const departmentId = this.editMultipleEmployeesDialog.departmentId;
      if (!departmentId) {
        this.$notify.error({title: t("提示"), message: t("请选择部门"), duration: 2000});
        return;
      }

      const updateRequests = this.selectedEmployees.map(employee =>
          app.methods.setEmployeeDepartment(employee.userId, departmentId).then(() => ({
            success: true,
            employee
          })).catch(error => {
            const message = error && error.response && error.response.data && error.response.data.message
                ? error.response.data.message
                : t("更新失败");
            this.$notify.error({
              title: t("修改 {p0} 的部门失败", { p0: employee.name }),
              message,
              duration: 0
            });
            return {success: false};
          })
      );

      const results = await Promise.all(updateRequests);
      if (results.some(result => result.success)) {
        this.$notify.success({title: t("修改部门成功"), message: null});
      }
      this.editMultipleEmployeesDialog.visible = false;
      this.editMultipleEmployeesDialog.departmentId = null;
      this.selectedEmployees = [];
      this.getEmployees();
    },
    selectionChanged(itemSelected) {
      this.selectedEmployees = itemSelected;
    },
    isEmployeeSelected(employee) {
      return this.selectedEmployees.some(item => item.userId === employee.userId);
    },
    toggleEmployeeSelection(employee, checked) {
      if (checked) {
        if (!this.isEmployeeSelected(employee)) {
          this.selectedEmployees = this.selectedEmployees.concat(employee);
        }
      } else {
        this.selectedEmployees = this.selectedEmployees.filter(item => item.userId !== employee.userId);
      }
    },
    handleEmployeeCommand(command, employee) {
      if (command === 'edit') {
        this.editEmployeeButtonClicked(employee);
        return;
      }
      if (command === 'remove') {
        this.removeEmployee(employee);
      }
    },
    metricValue(employee, key) {
      const value = Number(employee[key]);
      return Number.isFinite(value) ? value : 0;
    },
    metricGroupItemTotal(employee, group) {
      return group.items.reduce(
        (total, item) => total + this.metricValue(employee, item.key),
        0
      );
    },
    hasMetricGroupData(employee, group) {
      return this.metricValue(employee, group.totalKey) > 0
        || this.metricGroupItemTotal(employee, group) > 0;
    },
    visibleMetricGroups(employee) {
      return this.issueMetricGroups.filter(group => this.hasMetricGroupData(employee, group));
    },
    hasIssueMetrics(employee) {
      return this.visibleMetricGroups(employee).length > 0;
    },
    metricSegmentStyle(employee, group, item) {
      const total = this.metricValue(employee, group.totalKey);
      const itemTotal = this.metricGroupItemTotal(employee, group);
      const denominator = Math.max(total, itemTotal, 1);
      return {
        width: `${(this.metricValue(employee, item.key) / denominator) * 100}%`
      };
    },
    metricGroupDescription(employee, group) {
      const total = this.metricValue(employee, group.totalKey);
      const breakdown = group.items
        .map(item => `${item.label} ${this.metricValue(employee, item.key)}`)
        .join('，');
      return `${group.label} ${total}，${breakdown}`;
    },
    async removeEmployee(staff) {
      const companyId = this.companyId;
      if (!companyId) {
        this.$message.error(t("无法获取公司信息，删除失败"));
        return;
      }

      try {
        await this.$confirm(
          t("确认将“{p0}”移出当前企业吗？", { p0: staff.name || t("该员工") }),
          t("移出企业"),
          {
            confirmButtonText: t("移出"),
            cancelButtonText: t("取消"),
            confirmButtonClass: 'el-button--danger',
            type: 'warning'
          }
        );
        await axios.delete(`${process.env.VUE_APP_BASE_URL}/companies/${companyId}/employees/${staff.userId}`);
        this.selectedEmployees = this.selectedEmployees.filter(item => item.userId !== staff.userId);
        this.$message.success(t("员工已移出企业"));
        this.getEmployees();
      } catch (error) {
        if (error === 'cancel' || error === 'close') {
          return;
        }
        const message = error && error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : t("移出企业失败");
        this.$message.error(message);
      }
    }
  },
}
</script>

<style scoped>
.employee-toolbar-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.employee-toolbar-count {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--text-regular);
  font-size: 14px;
}

.employee-toolbar-count i {
  color: var(--primary-color);
}

.employee-toolbar-count strong {
  color: var(--text-primary);
}

.employee-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 16px;
}
.employee-card {
  border: 1px solid var(--border-light);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.employee-card--selected {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 2px var(--primary-soft);
}
.employee-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 8px;
}
.employee-card-name {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary);
}
.employee-card-name__text {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.employee-card-name .el-tag {
  flex: 0 0 auto;
}
.employee-card-controls {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 6px;
}
.employee-select-button,
.employee-actions-button {
  display: inline-flex;
  height: 30px;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--border-light);
  border-radius: 8px;
  background: var(--surface-color);
  color: var(--text-muted);
  font: inherit;
  cursor: pointer;
  transition: border-color 0.2s ease, background-color 0.2s ease, color 0.2s ease;
}
.employee-select-button {
  gap: 6px;
  padding: 0 9px;
  font-size: 11px;
}
.employee-select-button__indicator {
  display: inline-flex;
  width: 13px;
  height: 13px;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  font-size: 10px;
}
.employee-select-button:hover,
.employee-actions-button:hover {
  border-color: var(--primary-color);
  background: var(--surface-hover);
  color: var(--primary-color);
}
.employee-select-button--active {
  border-color: var(--primary-color);
  background: var(--primary-soft);
  color: var(--primary-color);
}
.employee-select-button--active .employee-select-button__indicator {
  border-color: var(--primary-color);
  background: var(--primary-color);
  color: #fff;
}
.employee-actions-button {
  width: 30px;
  padding: 0;
  font-size: 17px;
}
.employee-select-button:focus-visible,
.employee-actions-button:focus-visible {
  outline: 3px solid rgba(7, 134, 201, 0.18);
  outline-offset: 2px;
}
.employee-card-row {
  display: flex;
  justify-content: space-between;
  padding: 4px 0;
  font-size: 14px;
}
.employee-card-label {
  color: var(--text-muted);
}
.employee-card-value {
  color: var(--text-primary);
}
.employee-card-metrics {
  display: flex;
  flex-direction: column;
  gap: 9px;
  margin-top: 12px;
}
.employee-metric-group {
  --metric-accent: var(--primary-color);
  --metric-accent-soft: var(--primary-soft);
  padding: 10px 11px 9px;
  border: 1px solid var(--border-light);
  border-radius: 11px;
  background: linear-gradient(135deg, var(--metric-accent-soft), var(--surface-hover) 48%);
}
.employee-metric-group--solution {
  --metric-accent: #e8792e;
  --metric-accent-soft: rgba(232, 121, 46, 0.1);
}
.employee-metric-equation {
  display: grid;
  grid-template-columns: 58px 12px minmax(0, 1fr);
  align-items: center;
  gap: 7px;
}
.employee-metric-total {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 1px;
}
.employee-metric-total > span {
  color: var(--metric-accent);
  font-size: 11px;
  font-weight: 600;
}
.employee-metric-total > div {
  display: flex;
  align-items: baseline;
  gap: 3px;
}
.employee-metric-total strong {
  color: var(--text-primary);
  font-size: 23px;
  font-variant-numeric: tabular-nums;
  line-height: 1.15;
}
.employee-metric-total small {
  color: var(--text-muted);
  font-size: 10px;
}
.employee-metric-equals {
  color: var(--text-muted);
  font-size: 16px;
  font-weight: 600;
}
.employee-metric-breakdown {
  display: grid;
  min-width: 0;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 9px;
}
.employee-metric-item {
  position: relative;
  display: flex;
  min-width: 0;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  padding: 5px 2px;
  border-radius: 7px;
  background: var(--surface-color);
}
.employee-metric-item + .employee-metric-item::before {
  position: absolute;
  top: 50%;
  left: -7px;
  color: var(--text-muted);
  font-size: 10px;
  font-weight: 600;
  content: "+";
  transform: translateY(-50%);
}
.employee-metric-item strong {
  color: var(--metric-status-color);
  font-size: 15px;
  font-variant-numeric: tabular-nums;
  line-height: 1.1;
}
.employee-metric-item span {
  max-width: 100%;
  overflow: hidden;
  color: var(--text-muted);
  font-size: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.employee-metric-item--danger,
.employee-metric-bar__segment--danger {
  --metric-status-color: #e85757;
}
.employee-metric-item--warning,
.employee-metric-bar__segment--warning {
  --metric-status-color: #e99a31;
}
.employee-metric-item--success,
.employee-metric-bar__segment--success {
  --metric-status-color: #28a86b;
}
.employee-metric-bar {
  display: flex;
  height: 4px;
  margin-top: 8px;
  overflow: hidden;
  border-radius: 999px;
  background: var(--border-light);
}
.employee-metric-bar__segment {
  min-width: 0;
  background: var(--metric-status-color);
  transition: width 0.25s ease;
}
.employee-metric-bar__segment:first-child {
  border-radius: 999px 0 0 999px;
}
.employee-metric-bar__segment:last-child {
  border-radius: 0 999px 999px 0;
}
.employee-empty {
  text-align: center;
  color: #909399;
  font-size: 13px;
  padding: 16px 0 8px;
}
@media (max-width: 768px) {
  .employee-toolbar-row {
    align-items: stretch;
    flex-direction: column;
  }

  .employee-cards {
    grid-template-columns: 1fr;
  }

  .employee-metric-equation {
    grid-template-columns: 54px 10px minmax(0, 1fr);
    gap: 5px;
  }

  .employee-select-button {
    width: 30px;
    padding: 0;
  }

  .employee-select-button > span:last-child {
    display: none;
  }
}

</style>
